import { render } from "./GameIndex.vue?vue&type=template&id=05b66d03"
import script from "./GameIndex.vue?vue&type=script&lang=js"
export * from "./GameIndex.vue?vue&type=script&lang=js"

import "./GameIndex.vue?vue&type=style&index=0&id=05b66d03&lang=scss"
script.render = render

export default script